"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _semanticUiReact = require("semantic-ui-react");

var _moment = _interopRequireDefault(require("moment"));

require("./FeaturedBlogPost.css");

var _proptypes = require("../../../../utils/proptypes");

var _Image = _interopRequireDefault(require("../../../../atoms/Image"));

var _ObjectUtils = _interopRequireDefault(require("../../../../utils/ObjectUtils"));

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var FeaturedBlogPost = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(FeaturedBlogPost, _React$PureComponent);

  var _super = _createSuper(FeaturedBlogPost);

  function FeaturedBlogPost() {
    (0, _classCallCheck2["default"])(this, FeaturedBlogPost);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(FeaturedBlogPost, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          heroImage = _this$props.heroImage,
          summary = _this$props.summary,
          publishedAt = _this$props.publishedAt,
          title = _this$props.title,
          slug = _this$props.slug;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        as: "h2"
      }, "Featured Post"), /*#__PURE__*/_react["default"].createElement(_gatsby.Link, {
        to: "/".concat(slug, "/")
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Item.Group, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Item, {
        className: "featured-blog-post"
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        src: heroImage,
        imageQuery: heroImage
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Item.Content, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Item.Header, null, title), _ObjectUtils["default"].isRenderable(publishedAt) && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Item.Meta, null, (0, _moment["default"])(publishedAt).format('LL')), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Item.Description, null, summary))))));
    }
  }]);
  return FeaturedBlogPost;
}(_react["default"].PureComponent);

exports["default"] = FeaturedBlogPost;
FeaturedBlogPost.propTypes = {
  title: _propTypes["default"].string.isRequired,
  summary: _propTypes["default"].string.isRequired,
  publishedAt: _propTypes["default"].string,
  heroImage: _propTypes["default"].oneOf(_propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].arrayOf(_proptypes.GatsbyImagePropType)),
  slug: _propTypes["default"].string.isRequired
};
FeaturedBlogPost.defaultProps = {
  heroImage: null,
  publishedAt: null
};